import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {URL} from '../../constants/urls.constants'
import {Token} from '../token/index';
import { Router } from '@angular/router';
import { PUBLIC_ROUTE } from 'src/app/constants/routes.constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  isProfileLoaded = false;
  public $profile: BehaviorSubject<any> = new BehaviorSubject(null);
  readonly changes = this.$profile.asObservable();
  profileData: any;
  constructor(
    private $http: HttpClient,
    private $token: Token,
    private $router: Router
  ) {
    this.listenChanges();
  }
  queryProfile(): Observable<void> {
    return new Observable((observer: Observer<void>) => {
      if (this.$token.hasValue) {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.$token.value}`);
        this.$http.get<Api.Response<any>>(URL.adminProfile, { headers }).subscribe((resp) => {
          this.isProfileLoaded = true;
          this.$profile.next(resp.data);
          // this.$router.navigateByUrl(LAYOUT_ROUTE.url);
          observer.next(resp.data);
          observer.complete();
        }, () => {
          this.isProfileLoaded = true;
          observer.next(null);
          observer.complete();
        });
      } else {
        this.next(null);
        this.isProfileLoaded = true;
        observer.next(this.$profile.getValue());
        observer.complete();
      }
    });
  }
  next(value) {
    this.$profile.next(value);
  }
  logout() {
    this.$http.post(URL.logout,{}).subscribe(data=>{
      this.next(0);
      localStorage.clear();
      this.$router.navigateByUrl(PUBLIC_ROUTE.url);
      // window.location.reload();
    })
  }
  listenChanges() {
    this.changes.subscribe(
      data => {
        this.profileData = data;
      }
    )
  }

  hasPermission(module: string, action: 'canCreate' | 'canRead' | 'canUpdate' | 'canDelete'): boolean {
    const profile = this.profileData;
    if (!profile) return false;
    if (profile.adminType === 'SUPER') return true;
    if (!profile.rolePermissions) return false;
    const modulePermission = profile.rolePermissions.find((p: any) => p.module === module);
    return modulePermission ? !!modulePermission[action] : false;
  }

  canCreate(module: string): boolean {
    return this.hasPermission(module, 'canCreate');
  }

  canRead(module: string): boolean {
    return this.hasPermission(module, 'canRead');
  }

  canUpdate(module: string): boolean {
    return this.hasPermission(module, 'canUpdate');
  }

  canDelete(module: string): boolean {
    return this.hasPermission(module, 'canDelete');
  }
}
